ActivitiesFilters = {
    init() {
        this.eToggleFilters = document.querySelector('.toggle-activities-filter');
        this.eFilter = document.querySelector('.activities-filters');
        this.eFilters = document.querySelectorAll('.activities-filters__item');
        this.eResetFilters = document.querySelector('.activities-filters__item--reset');
        this.eFilters?.forEach((item) => {
            item.addEventListener('click', (event) => {
                this.applyFilter(event);
            });
        });

        this.eToggleFilters?.addEventListener('click', () => {
            this.toggleFilters();
        });

        this.eResetFilters?.addEventListener('click', () => {
            this.resetFilters();
        });
    },
    toggleFilters() {
        this.eFilter?.classList.toggle('activities-filters--opened');

    },
    applyFilter(event) {
        event.preventDefault();
        event.currentTarget.classList.toggle('activities-filters__item--active');
        const currentFilters = document.querySelectorAll('.activities-filters__item--active:not(.activities-filters__item--reset)');
        let className;

        if (currentFilters.length === 0) {
            className = 'activities__item';
        } else {

            className = 'activities__item activities__item--hide';
        }

        document.querySelectorAll('.activities__item').forEach((elem) => {
            elem.className = className;
        });

        for (const filter of document.querySelectorAll('.activities-filters__item--active:not(.activities-filters__item--reset)')) {
            for (const item of document.querySelectorAll('.activities__item')) {
                if (filter.dataset.type == item.dataset.types) {
                    item.classList.remove('activities__item--hide');
                }
            }
        }

    },
    resetFilters() {
        document.querySelectorAll('.activities__item--hide').forEach((elem) => {
            elem.classList.remove('activities__item--hide');
        });
        document.querySelectorAll('.activities-filters__item--active').forEach((elem) => {
            elem.classList.remove('activities-filters__item--active');
        });
    },


}
export let ActivitiesFilters;